import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import CountUp from 'react-countup';
import set1 from '../img/set1.jpg'
import set2 from '../img/set2.jpg';
import set3 from '../img/set3.jpg';
import set4 from '../img/set4.jpg';

const Philosophy = () => {
  const [progress, setProgress] = useState([0, 0, 0]);
  const ref = useRef(null); // Create a ref for the component
  const isInView = useInView(ref, { once: true }); // Check if the component is in view

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgress([14, 8, 8]);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className='philosophy' ref={ref}>
      <div className='philosophy-list column1'>
        {[set1, set2, set3, set4].map((actor, index) => (
          <motion.img
            key={index}
            src={actor}
            alt={`Actor ${index + 1}`}
            className={`img-${index + 1}`}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }} // Animate based on visibility
            transition={{ duration: 0.6, ease: 'easeOut', delay: index * 0.2 }}
          />
        ))}
      </div>
      <motion.div
        className='philosophy-list column2'
        initial={{ opacity: 0, x: 20 }}
        animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 20 }} // Animate based on visibility
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <motion.p className='round' initial={{ opacity: 0 }} animate={isInView ? { opacity: 1 } : { opacity: 0 }} transition={{ delay: 0.5 }}>
          Art Director
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }} // Animate based on visibility
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.6 }}
        >
          Art Director
        </motion.h2>
        <motion.p
          className='para'
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }} // Animate based on visibility
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.7 }}
        >
          Mazhar Khan is a highly skilled art director with a remarkable career spanning television, films, and advertisements. Born on December 3, 1976, and based in Andheri West, Mumbai, Mazhar brings a wealth of creativity and expertise to the entertainment industry. Fluent in Hindi, English, Marathi, and Urdu, he has worked on a diverse array of projects, showcasing his versatility and dedication to his craft.
        </motion.p>

        <div className='philosophy-counter'>
          {progress.map((value, index) => (
            <motion.div
              key={index}
              className='philosophy-counter-list'
              initial={{ opacity: 0, y: 10 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }} // Animate based on visibility
              transition={{ duration: 0.6, ease: 'easeOut', delay: 0.8 + index * 0.2 }}
            >
              <h2><CountUp end={isInView ? value : 0} duration={3} />+</h2> {/* Animate count only when in view */}
              <p>{['TV Shows', 'AD Films', 'Movies'][index]}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Philosophy;
